import React from "react"
import { Link } from "gatsby"

import { getCategoryUrl } from "components/utils"

import cx from "classnames"
import * as s from "./post-category.module.sass"

const PostCategory = (props) => {
  const { category, parentClass } = props
  const categoryUrl = category ? getCategoryUrl(category.slug) : null

  const componentClass = cx({
    [s.component]: true,
    [parentClass]: parentClass,
  })

  return (
    <p className={componentClass}>
      {categoryUrl ? (
        <Link to={categoryUrl}>#{category.title}</Link>
      ) : (
        "No category"
      )}
    </p>
  )
}

export default PostCategory
